<div class="content-container" [class.loading]="loadingLevel === 'EMPLOYEES'">
    <ng-container *ngIf="integration">
        <ng-container
            *ngIf="'import.integrations.providers.' + integration.name.toUpperCase() | translate as integrationName"
        >
            <div class="header">
                <app-header
                    [title]="'import.integrations.steps.summary.subtitle' | translate: { integrationName }"
                    [subtitle]="'import.integrations.steps.summary.description' | translate: { integrationName }"
                >
                    <ui-button
                        (click)="onBack()"
                        [openInNewTab]="false"
                        [type]="'outline'"
                        [disabled]="isErrored || loadingLevel !== null"
                        size="mobile-shrink"
                        class="buttons"
                        ><mat-icon svgIcon="home" />
                        {{ 'import.integrations.steps.summary.buttons.goBack' | translate }}
                    </ui-button>
                </app-header>
            </div>
            <ui-banner *ngIf="isErrored" variant="danger">
                {{ 'import.integrations.steps.summary.employeesError' | translate: { integrationName } }}
            </ui-banner>
            <div class="content-container" [class.loading]="loadingLevel === 'SUMMARY'">
                <div *ngIf="importSummary" class="app-grid">
                    <div class="columns-8 flex align-items-end">
                        <div class="legend">
                            <div>
                                <mat-icon class="success" svgIcon="complete"></mat-icon>
                                {{ 'import.integrations.success' | translate }}&nbsp;&nbsp;
                                <span>{{ importSummary.success }}</span>
                            </div>
                            <div>
                                <mat-icon class="update" svgIcon="refresh"></mat-icon>
                                {{ 'import.integrations.skipped' | translate }}&nbsp;&nbsp;
                                <span>{{ importSummary.skipped }}</span>
                            </div>
                            <div>
                                <mat-icon class="warning" svgIcon="error"></mat-icon>
                                {{ 'import.integrations.error' | translate }}&nbsp;&nbsp;
                                <span>{{ importSummary.error }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <app-table
                    *ngIf="importEmployeeTable"
                    [table]="importEmployeeTable"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [showSearch]="false"
                    [showLoading]="false"
                    [showPagination]="false"
                >
                    <app-empty-state
                        label="{{ 'employees.directory.noEmployeesFound' | translate }}"
                        src="/assets/illustrations/magnifying-glass.png"
                    >
                    </app-empty-state>
                </app-table>
            </div>
        </ng-container>
    </ng-container>
</div>
